import { SchedulingGridViewState } from '..';
import { observer } from 'mobx-react';
import { SurfaceConstants } from 'owa-calendar-surface-core';
import { isSameDay, OwaDate, startOfDay, getTimestamp } from 'owa-datetime';
import TimeConstants from 'owa-datetime-utils/lib/TimeConstants';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import * as React from 'react';

const { scrollTopAdjustment } = SurfaceConstants;

export interface SchedulingGridScrollBehaviorProps {
    viewState: SchedulingGridViewState;
}

/**
 * Scrolls attached element to pixel offset of provided time
 */
@observer
export class SchedulingGridScrollBehavior extends React.Component<
    SchedulingGridScrollBehaviorProps,
    {}
> {
    private scrollContainer: HTMLElement;
    onAttach(scrollContainer: HTMLElement) {
        this.scrollContainer = scrollContainer;

        let event = this.props.viewState.selectionItem;
        if (!event) {
            return;
        }
        let startOffset = event.IsAllDayEvent
            ? getUserConfiguration().UserOptions.WorkingHours.WorkHoursStartTimeInMinutes
            : this.getOffset(event.Start, startOfDay(event.Start));
        this.scrollContainer.scrollTop = startOffset - scrollTopAdjustment;
    }

    render() {
        // VSO 40588: Evaluate achieving this scrolling without hijacking a render method.
        this.scrollToTime();
        return null;
    }

    private scrollToTime() {
        let { selectionItem, selectedDate } = this.props.viewState;
        if (!selectionItem) {
            return;
        }
        let { Start, End, IsAllDayEvent } = selectionItem;

        if (selectedDate === null || IsAllDayEvent) {
            // If there is nothing selected or the event is all day, do not scroll at all
            return;
        }

        let baseTime = startOfDay(selectedDate);
        let startOffset = this.getOffset(Start, baseTime);
        let endOffset = this.getOffset(End, baseTime);

        if (this.scrollContainer) {
            // execute the GBCR after the current render cycle finishes
            window.requestAnimationFrame(() => {
                let gridBounds: ClientRect = this.scrollContainer.getBoundingClientRect();

                // perform scroll if start end is off the boundaries
                if (
                    isSameDay(selectedDate, Start) &&
                    startOffset < this.scrollContainer.scrollTop
                ) {
                    this.scrollContainer.scrollTop = startOffset - scrollTopAdjustment;
                } else if (
                    isSameDay(selectedDate, End) &&
                    endOffset > this.scrollContainer.scrollTop + gridBounds.height
                ) {
                    this.scrollContainer.scrollTop =
                        endOffset - gridBounds.height + scrollTopAdjustment;
                }
            });
        }
    }

    private getOffset(time: OwaDate, baseTime: OwaDate) {
        return Math.ceil(
            (getTimestamp(time) - getTimestamp(baseTime)) / TimeConstants.MillisecondsIn1Min
        );
    }
}
